module.exports = __webpack_public_path__ + "static/logo-c23d9e5a669ae49d8950fa2f28140caa.png";